export default __webpack_public_path__ + "static/media/no-voucher.a3f3a79c.png";